import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {FileAttachment} from '../types/FileAttachment';


export const useGetFiles = (parentGuid: string, enabled: boolean) => {

    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['files', parentGuid],
        queryFn: async () => await apiClient.get('document/files',
            { params: { parentGuid: parentGuid } }) as FileAttachment[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading,
        refetch: refetch,
        isRefetching: isRefetching
    };
};
